export const dataProductList = len => {
		const out = []
		for (let i = 1; i <= len; i += 1) {
			const num = i.toString().padStart(3, '0')
			out.push({
				id: `${i}`,
				number: num,
				name: `Produktname_${num}`
			})
		}
		return out
	},
	columnsProductList = [
		{ Header: 'id', accessor: 'id', show: false },
		{ Header: 'Nummer', accessor: 'number' },
		{ Header: 'Bezeichnung', accessor: 'name' }
	],
	randomIntegerInRange = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min
